import { Splide } from "@splidejs/splide";
import { AutoScroll } from "@splidejs/splide-extension-auto-scroll";

export function slide() {
    window.addEventListener('DOMContentLoaded', function () {

        if (document.querySelector(".js-slide-auto--a")) {
            new Splide(".js-slide-auto--a", {
                fixedWidth: 380,
                type: "loop",
                focus: 0,
                pagination: false,
                arrows: false,
                breakpoints: {
                    768: {
                        fixedWidth: 221,
                    },
                },
                autoScroll: {
                    speed: .7,
                    pauseOnHover: false,
                },
            }).mount({ AutoScroll });
        }
        if (document.querySelector(".js-slide-auto--b")) {
            new Splide(".js-slide-auto--b", {
                fixedWidth: 380,
                type: "loop",
                focus: 0,
                pagination: false,
                arrows: false,
                breakpoints: {
                    768: {
                        fixedWidth: 221,
                    },
                },
                autoScroll: {
                    speed: .7,
                    pauseOnHover: false,
                },
            }).mount({ AutoScroll });
        }
        if (document.querySelector(".js-slide-text--a")) {
            new Splide(".js-slide-text--a", {
                fixedWidth: 985,
                gap: 40,
                type: "loop",
                focus: 0,
                pagination: false,
                arrows: false,
                breakpoints: {
                    768: {
                        fixedWidth: 492,
                        gap: 20,
                        autoScroll: {
                            speed: .5,  // SP表示時のスピードを更に低く設定
                        },
                    },
                },
                autoScroll: {
                    speed: .7,
                    pauseOnHover: false,
                },
            }).mount({ AutoScroll });
        }
        if (document.querySelector(".js-slide-text--b")) {
            new Splide(".js-slide-text--b", {
                fixedWidth: 985,
                gap: 40,
                type: "loop",
                focus: 0,
                pagination: false,
                arrows: false,
                breakpoints: {
                    768: {
                        fixedWidth: 492,
                        gap: 20,
                        autoScroll: {
                            speed: .5,  // SP表示時のスピードを更に低く設定
                        },
                    },
                },
                autoScroll: {
                    speed: .7,
                    pauseOnHover: false,
                },
            }).mount({ AutoScroll });
        }
    })

}
